import React from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'

import {
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  Button,
  Radio,
  RadioGroup,
  FormControl,
} from '@material-ui/core'
import { getVisibleConcreteMonitorDeviceIds } from '../../../state/DeviceById/selectors'
import { State } from '../../../types'

import {
  getShowItgLog,
  getShowName,
  getShowSurfaceTemp,
} from '../../../state/SystemCache/selectors'
import { setShowName } from '../../../state/SystemCache/actions'
import {
  toggleShowItgLog,
  toggleShowSurfaceTemp,
} from '../../../state/SystemCache/operations'
import { getLoginUser } from '../../../state/Auth/selectors'
import { updateUserLayout } from '../../../state/Firebase/operations'
import ConcreteDeviceForm from './ConcreteDeviceForm'
import ConcreteTopicForm from './ConcreteTopicForm'

type Props = {
  deviceIds: string[]
}

function ConcreteConfigForm(props: Props) {
  const showName = useSelector(getShowName)
  const showItgLog = useSelector(getShowItgLog)
  const showSurfaceTemp = useSelector(getShowSurfaceTemp)
  const user = useSelector(getLoginUser)

  const { allowSurfaceTemp } = useSelector(getLoginUser)
  const [columnCount, setColumnCount] = React.useState(
    String(user.jutenLayout || 1),
  )

  const dispatch = useDispatch()

  const handleColumnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setColumnCount(event.target.value)
  }
  const handleSubmit = () => {
    if (user.jutenLayout !== Number(columnCount)) {
      dispatch(updateUserLayout(Number(columnCount)))
    }
  }

  return (
    <div style={{ padding: '12px' }}>
      <Typography variant="h4">表示設定</Typography>
      <ConcreteTopicForm />

      <div style={{ display: 'grid' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showItgLog}
              onChange={e => dispatch(toggleShowItgLog())}
            />
          }
          label={'データ連携ログ表示'}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={showName}
              onChange={e => {
                dispatch(setShowName(!showName))
              }}
            />
          }
          label={'名称表示'}
        />
        {allowSurfaceTemp && (
          <FormControlLabel
            control={
              <Checkbox
                checked={showSurfaceTemp}
                onChange={e => {
                  dispatch(toggleShowSurfaceTemp())
                }}
              />
            }
            label={'温度表示'}
          />
        )}
      </div>
      {props.deviceIds.map(id => (
        <ConcreteDeviceForm key={id} deviceId={id} />
      ))}
      <Typography variant="caption">
        ※優先度の数値が早い順番に表示されます。
        空白・未設定は最後に表示されます。
      </Typography>
      <Box display="grid" gridTemplateColumns="1fr 2fr" alignItems="center">
        <Box display="flex" alignItems="center">
          <Typography variant="h6">初期表示</Typography>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <FormControl component="fieldset">
            <RadioGroup row value={columnCount} onChange={handleColumnChange}>
              <FormControlLabel value="1" control={<Radio />} label="1列" />
              <FormControlLabel value="2" control={<Radio />} label="2列" />
              <FormControlLabel value="4" control={<Radio />} label="4列" />
            </RadioGroup>
            <Typography variant="caption">
              ※画面幅が小さい場合は1列で固定されます
            </Typography>
          </FormControl>

          <Button
            disabled={columnCount === String(user.jutenLayout || 1)}
            onClick={e => handleSubmit()}
          >
            変更する
          </Button>
        </Box>
      </Box>
    </div>
  )
}

const conn = connect((state: State) => {
  return {
    deviceIds: getVisibleConcreteMonitorDeviceIds(state, false),
  }
})

export default conn(ConcreteConfigForm)
